/* Chilero502 — comportamiento propio (sin librerías). Se carga una sola vez desde snippets/ch-head.liquid. */
(function () {
  if (window.__chInit) return;
  window.__chInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  /* ---------- Entradas al hacer scroll ---------- */
  function initReveal(root) {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('ch-visible');
            observer.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    var vh = window.innerHeight || 800;
    (root || document).querySelectorAll('.ch-reveal').forEach(function (el) {
      if (el.dataset.chReveal) return;
      el.dataset.chReveal = '1';
      // Solo se esconde lo que todavía no se ve: nada parpadea arriba y sin JS todo queda visible.
      if (el.getBoundingClientRect().top > vh * 0.92) {
        el.classList.add('ch-pre');
        observer.observe(el);
      }
    });
  }

  /* ---------- Texto del botón de compra (también al cambiar de variante) ---------- */
  function initTextoBoton() {
    if (!window.customElements) return;
    customElements.whenDefined('product-form').then(function () {
      var PF = customElements.get('product-form');
      if (!PF || PF.prototype.__chTexto) return;
      var original = PF.prototype.toggleSubmitButton;
      PF.prototype.toggleSubmitButton = function (disable, text) {
        original.apply(this, arguments);
        var btn = this.submitButton;
        if (btn && btn.dataset.chTexto && !btn.hasAttribute('disabled') && this.submitButtonText) {
          this.submitButtonText.textContent = btn.dataset.chTexto;
        }
      };
      PF.prototype.__chTexto = true;
    });
  }

  /* ---------- Barra de compra fija (celular) ---------- */
  function initBarra(root) {
    (root || document).querySelectorAll('.ch-barra[data-section]').forEach(function (barra) {
      if (barra.dataset.chInit) return;
      var id = barra.dataset.section;
      var principal = document.getElementById('ProductSubmitButton-' + id);
      if (!principal) { barra.hidden = true; return; }
      barra.dataset.chInit = '1';
      barra.hidden = false;
      document.body.classList.add('ch-con-barra');

      var btn = barra.querySelector('[data-ch-barra-boton]');
      var precioDestino = barra.querySelector('[data-ch-barra-precio]');
      var precioOrigen = document.getElementById('price-' + id);
      var textoNormal = btn ? btn.textContent.trim() : '';

      function copiarPrecio() {
        if (precioOrigen && precioDestino) precioDestino.innerHTML = precioOrigen.innerHTML;
      }
      function copiarEstado() {
        if (!btn) return;
        var off = principal.hasAttribute('disabled');
        btn.disabled = off;
        var span = principal.querySelector('span');
        btn.textContent = off && span ? span.textContent.trim() : textoNormal;
      }
      copiarPrecio();
      copiarEstado();

      if ('MutationObserver' in window) {
        if (precioOrigen) new MutationObserver(copiarPrecio).observe(precioOrigen, { childList: true, subtree: true, characterData: true });
        new MutationObserver(copiarEstado).observe(principal, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
      }

      // «Cargando» en la barra: copia el estado real del botón principal mientras se agrega al carrito
      function marcarCarga() {
        if (!btn) return;
        var cargando = principal.classList.contains('loading');
        btn.classList.toggle('is-cargando', cargando);
        btn.setAttribute('aria-busy', cargando ? 'true' : 'false');
      }
      if (btn && 'MutationObserver' in window) {
        new MutationObserver(marcarCarga).observe(principal, { attributes: true, attributeFilter: ['class'] });
      }

      if (btn) {
        btn.addEventListener('click', function () {
          if (principal.hasAttribute('disabled') || btn.classList.contains('is-cargando')) return;
          principal.click();
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            barra.classList.toggle('is-visible', !e.isIntersecting);
          });
        }, { threshold: 0 }).observe(principal);
      } else {
        barra.classList.add('is-visible');
      }
    });
  }

  /* ---------- Primer video del producto: se reproduce solo y sin sonido ---------- */
  function initVideoAuto(root) {
    (root || document).querySelectorAll('[data-ch-video-auto="true"]').forEach(function (seccion) {
      if (seccion.dataset.chVideo) return;
      seccion.dataset.chVideo = '1';
      var primero = seccion.querySelector('.product__media-list .product__media-item');
      if (!primero) return;
      var dm = primero.querySelector('deferred-media');
      if (!dm) return;
      var tpl = dm.querySelector('template');
      var video = tpl && tpl.content && tpl.content.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('loop', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('preload', 'metadata');
      var arrancar = function () {
        customElements.whenDefined('deferred-media').then(function () {
          if (dm.getAttribute('loaded') || typeof dm.loadContent !== 'function') return;
          dm.loadContent(false);
          var v = dm.querySelector('video');
          if (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); arrancar(); }
        });
        io.observe(dm);
      } else {
        arrancar();
      }
    });
  }

  /* ---------- Opcional: después de pedir, ir directo a la compra ---------- */
  function initIrAPagar() {
    if (!document.querySelector('[data-ch-ir-a-pagar="true"]')) return;
    if (window.__chIrAPagar || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    window.__chIrAPagar = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evento) {
      if (evento && evento.source === 'product-form') {
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'checkout';
      }
    });
  }

  // Fila de departamentos: marca si hay más a la derecha/izquierda (desvanecido) y deja deslizarla con la rueda del ratón.
  function initFilaDeptos(root) {
    (root || document).querySelectorAll('.ch-chips-deptos').forEach(function (fila) {
      if (fila.dataset.chFila) return;
      fila.dataset.chFila = '1';
      function marcar() {
        var fin = fila.scrollLeft + fila.clientWidth < fila.scrollWidth - 2;
        var inicio = fila.scrollLeft > 2;
        fila.dataset.desborde = (inicio ? 'inicio ' : '') + (fin ? 'fin' : '');
      }
      fila.addEventListener('scroll', marcar, { passive: true });
      window.addEventListener('resize', marcar);
      fila.addEventListener('wheel', function (e) {
        if (fila.scrollWidth <= fila.clientWidth || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        e.preventDefault();
        fila.scrollLeft += e.deltaY;
      }, { passive: false });
      var activo = fila.querySelector('.is-activo');
      if (activo && activo.offsetLeft + activo.offsetWidth > fila.clientWidth) {
        fila.scrollLeft = activo.offsetLeft - 24;
      }
      marcar();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(marcar);
    });
  }

  // Cuenta regresiva honesta: días que faltan para el 25 de diciembre según la fecha del teléfono.
  function initNavidad(root) {
    (root || document).querySelectorAll('[data-ch-navidad]').forEach(function (el) {
      var hoy = new Date();
      var inicio = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
      var navidad = new Date(hoy.getFullYear(), 11, 25);
      var faltan = Math.round((navidad - inicio) / 86400000);
      var texto = el.querySelector('[data-ch-navidad-texto]');
      if (faltan < 0 || !texto) { el.hidden = true; return; }
      el.hidden = false;
      texto.innerHTML = faltan === 0 ? '¡Feliz Navidad!' : (faltan === 1 ? '<span class="ch-cuenta__faltan">Falta </span><b>1</b> día para Navidad' : '<span class="ch-cuenta__faltan">Faltan </span><b>' + faltan + '</b> días para Navidad');
    });
  }

  // Fecha de hoy en Guatemala (aunque el teléfono tenga otra zona), como fecha UTC a medianoche.
  function hoyGT() {
    var s;
    try { s = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Guatemala', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { var d = new Date(); s = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    var p = s.split('-');
    return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
  }
  // Feriados fijos de Guatemala (mes-día): ese día no hay entregas
  var FERIADOS = ['01-01', '05-01', '06-30', '09-15', '10-20', '11-01', '12-25'];
  function habil(d) {
    var md = ('0' + (d.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + d.getUTCDate()).slice(-2);
    return d.getUTCDay() !== 0 && FERIADOS.indexOf(md) === -1;
  }
  function sumarHabiles(desde, n) {
    var d = new Date(desde.getTime()); var k = 0;
    while (k < n) { d.setUTCDate(d.getUTCDate() + 1); if (habil(d)) k++; }
    return d;
  }
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  // «Te llega entre el miércoles 4 y el viernes 6 de noviembre»
  function initLlega(root) {
    (root || document).querySelectorAll('[data-ch-llega]').forEach(function (el) {
      var hoy = hoyGT();
      var a = sumarHabiles(hoy, parseInt(el.dataset.min, 10) || 1);
      var b = sumarHabiles(hoy, parseInt(el.dataset.max, 10) || 3);
      var fa = DIAS[a.getUTCDay()] + ' ' + a.getUTCDate() + (a.getUTCMonth() !== b.getUTCMonth() ? ' de ' + MESES[a.getUTCMonth()] : '');
      var fb = DIAS[b.getUTCDay()] + ' ' + b.getUTCDate() + ' de ' + MESES[b.getUTCMonth()];
      el.querySelector('[data-ch-llega-texto]').innerHTML = 'Te llega entre el <b>' + fa + '</b> y el <b>' + fb + '</b>';
      el.hidden = false;
    });
  }

  // Aviso de Navidad con fecha real (Ajustes del tema); después de esa fecha no sale.
  function initLimite(root) {
    (root || document).querySelectorAll('[data-ch-limite]').forEach(function (el) {
      var p = (el.dataset.chLimite || '').split('-');
      if (p.length !== 3) return;
      var limite = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
      if (isNaN(limite) || hoyGT() > limite) { el.hidden = true; return; }
      var fecha = DIAS[limite.getUTCDay()] + ' ' + limite.getUTCDate() + ' de ' + MESES[limite.getUTCMonth()];
      var span = el.querySelector('[data-ch-limite-texto]');
      span.textContent = (el.dataset.texto || '').replace('{fecha}', fecha);
      el.hidden = false;
    });
  }

  function initTodo(root) {
    initLlega(root);
    initLimite(root);
    initNavidad(root);
    initFilaDeptos(root);
    initReveal(root);
    initBarra(root);
    initVideoAuto(root);
    initIrAPagar();
  }

  initTextoBoton();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
